
import packageInfo from '../../package.json';
// environment.base.ts
export const baseEnvironment = {
  name: packageInfo.name,
  version: packageInfo.version,
  // Controls whether Fuse Mock API services are wired into the app
  // Should be false for production builds
  useMockApi: false,

  delk: 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjcxMzJkZWI2LTc3N2QtNDU5MS1hYjcwLWUyZDAyOTgxM2IxMSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUxCn0=.oWxUTSYz3uyewjGunEcks2bAEDUJvWLnTPjPks85RXdhEcMqE3jVxrgeMfHcU+1iUVzTatHszxtAhZiRd5RGrAE67D18DSTvohxjNk80/XyETas4RJtwhg4jEOP//RvMen2jdQ==',

  copyright: 'Bakelor RTLS Navizard Copyright Reserved',

  firebaseConfig: {
    apiKey: "AIzaSyB-UJhrysgoDFPYh7Tdui-AVQfMGXseCqw",
    authDomain: "ab-rtls-pn.firebaseapp.com",
    projectId: "ab-rtls-pn",
    storageBucket: "ab-rtls-pn.appspot.com",
    messagingSenderId: "921218140601",
    appId: "1:921218140601:web:9911ffbedef0322b79ce68"
  }
};
